import { useMemo } from "react";

// Components
import Author from "components/Table/Author";

function ContactDetailsData(contactList) {
  const contactRows = useMemo(() => {
    if (!contactList || contactList.length === 0) return [];

    return contactList.map((item, index) => ({
      srNo: <Author name={index + 1} />,
      function: <Author name={item.function} />,
      name: <Author name={item?.name} />,
      email: <Author name={item?.email} style={{ textTransform: "none" }} />,
      phone: <Author name={item?.phone} />,
    }));
  }, [contactList]);

  return {
    contactColumns: [
      { Header: "No.", accessor: "srNo", width: "5%" },
      { Header: "Function", accessor: "function", width: "20%" },
      { Header: "Name", accessor: "name", align: "left", width: "30%" },
      { Header: "Email Address", accessor: "email", align: "left", width: "30%" },
      { Header: "Phone Number", accessor: "phone", align: "left", width: "30%" },
    ],

    contactRows,
  };
}

export default ContactDetailsData;
